import { Component } from '@angular/core';

import { Sitecore } from '@frontend/sports/common/client-config-data-access';

import { BetslipOverAskPickParticipantBaseComponent } from '../../betslip-over-ask-pick-participant-base.component';

@Component({
    selector: 'bs-betslip-over-aks-pick-participant',
    templateUrl: './betslip-over-ask-pick-participant.component.html',
    standalone: false,
})
export class BetslipOverAskPickParticipantComponent extends BetslipOverAskPickParticipantBaseComponent {
    constructor(sitecore: Sitecore) {
        super(sitecore);
    }
}
